import { apiMiddleware, registerStores } from 'mutants-microfx';
import stores from './store';
registerStores(stores);
import requestInterceptor from './api/request-interceptor';
import responseInterceptor from './api/response-interceptor';
// 注册中间件
apiMiddleware.registerAxiosMiddleWare(function (axios) { return requestInterceptor(axios); });
apiMiddleware.registerAxiosMiddleWare(function (axios) { return responseInterceptor(axios); });
import User from './model/User';
import Channel from './model/Channel';
import ClientInfo from './model/ClientInfo';
import tApi from './api/TplusApi';
import tApiV2 from './api/TplusApiV2';
import LoginApi from './api/LoginApi';
import serverLog from './log/ServerLog';
import UIConfirm from './components/UIConfirm';
import LogoutMW from './middleware/LogoutMW';
var registerLogoutMiddleWare = LogoutMW.registerLogoutMiddleWare;
var clearLogoutMiddleWare = LogoutMW.clearMiddlewares;
import registerBizError from './bizError/registerBizError';
export { User, Channel, ClientInfo, tApi, tApiV2, LoginApi, serverLog, UIConfirm, registerLogoutMiddleWare, clearLogoutMiddleWare, registerBizError };

//# sourceMappingURL=index.js.map
